/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Faq_2_QuestionInputs */

const en_svc_research_faq_2_question = /** @type {(inputs: Svc_Research_Faq_2_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can it use our own data as well as the web?`)
};

const lv_svc_research_faq_2_question = /** @type {(inputs: Svc_Research_Faq_2_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai tas var izmantot mūsu datus, ne tikai internetu?`)
};

/**
* | output |
* | --- |
* | "Can it use our own data as well as the web?" |
*
* @param {Svc_Research_Faq_2_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_faq_2_question = /** @type {((inputs?: Svc_Research_Faq_2_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Faq_2_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_faq_2_question(inputs)
	return en_svc_research_faq_2_question(inputs)
});